'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import './ButtonBar.css'


exports.default = function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      innerRef = _ref.innerRef;
  return _react2.default.createElement('div', {
    ref: innerRef,
    className: 'ButtonBar ' + (className || '')
  }, children);
};